import React, { useState } from "react";
import {
  Typography,
  Box,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  Tabs,
  Tab,
} from "@mui/material";
import { Notifications, CalendarToday } from "@mui/icons-material";
import AppHeaderBar from "../../components/AppBar/appBar";
import OverView from "./OverView";
import Payments from "./Payments";
import Transcation from "./Transcation";
import Commission from "./Commission";
import Report from "./Report";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
export default function AdminFinancialManagement({ onBackScreenName }) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  return (
    <Box component="main" sx={{ flexGrow: 1, bgcolor: "#EEF2FF", p: 2 }}>
      <Box
      // component="main"
      // sx={{
      //   flexGrow: 1,
      //   bgcolor: "#EEF2FF",
      //   p: 3,
      //   overflowY: "auto",
      //   display: "flex",
      //   flexDirection: "column",
      //   height: "100vh",
      // }}
      >
        <AppHeaderBar
          title={"Financial Management"}
          onBackScreenName={handleScreeName}
        />

        <Tabs value={value} onChange={handleChange} aria-label="settings tabs">
          <Tab label="Overview" sx={{ textTransform: "none" }} />
          <Tab label="Regular Vendor Payment" sx={{ textTransform: "none" }} />
          {/* <Tab label="Listing Vendor Payment" sx={{ textTransform: "none" }} /> */}
          <Tab label="Agent Payment" sx={{ textTransform: "none" }} />
          {/* <Tab label="Report" sx={{ textTransform: "none" }} /> */}
        </Tabs>

        <TabPanel value={value} index={0}>
          <OverView />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Payments />
        </TabPanel>
        {/* <TabPanel value={value} index={2}>
          <Transcation />
        </TabPanel> */}
        <TabPanel value={value} index={2}>
          <Commission />
        </TabPanel>
        {/* <TabPanel value={value} index={4}>
          <Report />
        </TabPanel> */}
      </Box>
    </Box>
  );
}
